<template>
  <div class="bg-white">
  <header class="mdc-top-app-bar top-app-bar top-header">
    <div class="mdc-top-app-bar__row">
<!--      <section class="mdc-top-app-bar__section mdc-top-app-bar__section&#45;&#45;align-start">-->
<!--        <button class="material-icons mdc-top-app-bar__navigation-icon mdc-icon-button hide-desktop navToggle"-->
<!--                aria-label="Open navigation menu">menu</button>-->
<!--        <span class="mdc-top-app-bar__title t-subtitle4 pdl-12">CAMPUS NAME</span>-->
<!--      </section>-->
    </div>
  </header>
    <div class="d-flex flex-column h-full">
      <main class="main-wrapper full flex-grow-1 h-full">
        <div class="container container--small h-full">
          <div class="h-full d-flex  justify-content-center">
            <div class="mgt-150 d-flex align-items-center   flex-column">
              <img src="@/images/idp_redirect_1.svg" alt="" class="icon200">
              <div class="mgt-4 t-headline10 font-b t-line-h-33 t-color-headlineBlack">Redirecting</div>
              <div class="mgt-8 t-body1 font-r t-line-h-21 t-color-bodyGrayA">Authentication redirect. Please wait for a moment.</div>
              <div class="mgt-200"></div>
            </div>
          </div>
        </div>
      </main>
    </div>

  </div>
</template>

<script>
// @ is an alias to /src
import { mapMutations } from "vuex";
import {commonMixin} from "@/mixins/common";
import memberApi from "@/api/memberApi";
import loginApi from "@/api/loginApi";
import popupApi from "@/api/popupApi";
import snackMessage from "@/plugins/snackMessage";
import localStorageUtil from "@/utils/localStorageUtil";
import { userMixin } from "@/mixins/user";

export default {
  name: 'token',

  mixins: [commonMixin,userMixin],

  data() {
    return {
      isIdpService: localStorageUtil.isIdpServiceValidate()
    }
  },

  mounted() {
	  const jwt = this.$route.query.jwt;
		if (!jwt) {
			document.location.replace("/");
		}
	  this.idpLogin(jwt);
  },

	methods: {
		...mapMutations("dormancy", [
			"MUTATION_STATE_CATEGORY",
			"MUTATION_USER_DATA",
		]),

		idpLogin(jwt) {
			loginApi.idpLogin({'jwt': jwt})
					.then((loginResponse) => {
						loginApi.setAuthInHeader(loginResponse.data.data.token);
						localStorageUtil.setToken(loginResponse.data.data.token);
						this.MUTATION_USER_DATA(loginResponse.data.data)
						memberApi.getMemberInfo().then((response) => {
							let responseData = response.data.data;
							let userParams = {
								userId: responseData.userId, password: "", device: {type: "WEB"}
							}
							localStorage.setItem("userParams", JSON.stringify(userParams));
							if (!localStorage.getItem('bgColors')) {
								let colors = ['#fb6262', '#d16443d4', '#4d9fd6', '#40bca7', '#9db82f', '#76a0d6', '#a967d4', '#696481', '#4c438d', '#fe7947'];
								let randomColor = colors[Math.floor(Math.random() * colors.length)];
								localStorage.setItem('bgColors', `background-color:${randomColor}`)
							}

							if (!localStorage.getItem('firstChar')) {
								let fullNames = responseData ? responseData.name.fullName : "";
								let firstCharOfName = fullNames.slice(0, 1);
								localStorage.setItem('firstChar', firstCharOfName)
							}
							this.checkUser();
						});
					}).catch((err) => {
						this.loginErrorProcess(err);
			});
		},
		loginErrorProcess(err) {
			console.log(err)
			const responseData = err.response.data.meta
			if (responseData.errCode === 1200) { // 관리자 승인 대기중(Waiting for administrator approval)
				// 매장 관리자 승인 대기중 입니다. 관리자에게 문의해주세요.
				snackMessage(this.$t('356'))
			} else if (responseData.errCode === 1201) { // 관리자 승인 대기중(Waiting for administrator approval)
				// 매장 관리자 승인 대기중 입니다. 관리자에게 문의해주세요.
				this.$alert({
					title: this.$t('779'), //가입 승인 대기 상태입니다.
					content: this.$t('780') + '<br>' + this.$t('781', {str: '<a class="pdl-4 t-body1 t-color-signBlue font-r t-decoration-underline" href="mailto:' + BRAND_MANAGER_EMAIL + '">' + BRAND_MANAGER_EMAIL + '</a>'}) + '<br>' + this.$t('782', {str: '<a class="pdl-4 t-body1 t-color-signBlue font-r t-decoration-underline" href="tel:' + BRAND_MANAGER_PHONE + '">' + BRAND_MANAGER_PHONE + '</a>'}),
					accept: this.$t('783')
				}).then(() => {
					this.$moveIdpLogout();
				}).catch(() => {
				});
			} else if (responseData.errCode === 1202) {
				this.$alert({
					title: this.$t('779'), //가입 승인 대기 상태입니다.
					content: this.$t('780') + '<br>' + this.$t('781', {str: '<a class="pdl-4 t-body1 t-color-signBlue font-r t-decoration-underline" href="mailto:' + BRAND_MANAGER_EMAIL + '">' + BRAND_MANAGER_EMAIL + '</a>'}) + '<br>' + this.$t('782', {str: '<a class="pdl-4 t-body1 t-color-signBlue font-r t-decoration-underline" href="tel:' + BRAND_MANAGER_PHONE + '">' + BRAND_MANAGER_PHONE + '</a>'}),
					accept: this.$t('783')
				}).then(() => {
					this.$moveIdpLogout();
				}).catch(() => {
				})
			} else if (responseData.errCode === 1204) {
				this.$alert({
					title: this.$t('1482'), //가입 승인 대기 상태입니다.
					content: this.$t('1483') + '<br>' + this.$t('1484') + ': ' + '<a class="pdl-4 t-body1 t-color-signBlue font-r t-decoration-underline" href="mailto:' + BRAND_MANAGER_EMAIL + '">' + BRAND_MANAGER_EMAIL + '</a>' + '<br>' + this.$t('1485') + ': ' + '<a class="pdl-4 t-body1 t-color-signBlue font-r t-decoration-underline" href="tel:' + BRAND_MANAGER_PHONE + '">' + BRAND_MANAGER_PHONE + '</a>',
					accept: this.$t('1486')
				}).then(() => {
					this.$moveIdpLogout();
				}).catch(() => {
				})
			} else if (responseData.errCode === 1205) {
				this.$alert({
					title: this.$t('1914'), //가입 승인 대기 상태입니다.
					content: this.$t('1915') + " " + this.$t('1916') + '<br>' + this.$t('1917', {str: '<a class="pdl-4 t-body1 t-color-signBlue font-r t-decoration-underline" href="mailto:' + BRAND_MANAGER_EMAIL + '">' + BRAND_MANAGER_EMAIL + '</a>'}) + '<br>' + this.$t('1918', {str: '<a class="pdl-4 t-body1 t-color-signBlue font-r t-decoration-underline" href="tel:' + BRAND_MANAGER_PHONE + '">' + BRAND_MANAGER_PHONE + '</a>'}),
					accept: this.$t('1919')
				}).then(() => {
					this.$moveIdpLogout();
				}).catch(() => {
				})
			} else if (responseData.errCode === 1105) {
				this.$alert({
					content: this.$t('1875'),
					accept: this.$t('1876')
				}).then(() => {
					this.$moveIdpLogout();
				}).catch(() => {
				})
			} else if (responseData.errCode === 1335) {  //아이디 계정 일시 정지(Suspend Account)
				// 로그인 정보가 5회 이상 일치하지 않아 30분간 로그인 정지되었습니다. 30분 후 다시 시도해주세요.
				this.$snackOpen({contents: this.$t('323'), btnDisplayYN: false}).then(() => {
				})
			} else {
				snackMessage(this.$t('356'))
			}
		},
	}
}
</script>


<style>

</style>
